import axiosInstance from "./axiosInstance";
import { createAsyncThunk } from "@reduxjs/toolkit";


export const fetchProducts = createAsyncThunk(
  "product/fetchProducts",
  async ({page,limit},{ rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/products?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response.data.errors || [error.response.data.error]
      );
    }
  }
);
export const fetchProductByID = createAsyncThunk(
  "product/fetchProductByID",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/products/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue([error.response.data.message]);
    }
  }
);
  export const fetchProductsByCategory = createAsyncThunk(
    "product/fetchProductsByCategory",
    async (categoryId, { rejectWithValue }) => {
      try {
        const response = await axiosInstance.get(`/products-category/${categoryId}`);
        return response.data;
      } catch (error) {
        return rejectWithValue([error.response.data.message]);
      }
    }
  );
  export const fetchCategories = createAsyncThunk(
    "product/fetchCategories",
    async (_,{ rejectWithValue }) => {
      try {
        const response = await axiosInstance.get("/categories");
        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response.data.errors || [error.response.data.error]
        );
      }
    }
  );

